/** Tokens visuais — lançamentos de vendas (marca TNV) */
export const FINANCEIRO_ACCENT = "#F96030";

export const financeiroToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${FINANCEIRO_ACCENT}`,
};
